// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"OrderMainSec_Wrapper___-q2T","TopSec":"OrderMainSec_TopSec__3MpvT","BottomSec":"OrderMainSec_BottomSec__2M1ba"};